var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { injectGlobal } from '@emotion/css';
import { useEffect, useRef, useState } from 'react';
import { sizeMapWidth } from "./ResultClockDark";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var _styles = injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n.moly-progress-circle {\n  --percent: 0;\n  /* \u767E\u5206\u6570 */\n  // --size: 70px;\n  --size: 66px;\n  /* \u5C3A\u5BF8\u5927\u5C0F */\n  --border-width: 6px;\n  /* \u73AF\u5BBD\uFF08\u7C97\u7EC6\uFF09 */\n  --color: #F7A600;\n  /* \u4E3B\u8272 */\n  --inactive-color: raba(247, 166, 0, 0.16);\n  // --inactive-color: #ccc;\n  /* \u8F85\u52A9\u8272 */\n\n  position: relative;\n  \n  border-radius: 50%;\n}\n.moly-progress-circle-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  white-space: nowrap;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* SVG \u5BB9\u5668 */\n.moly-progress-circle>svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n/* \u8FDB\u5EA6\u6761\u5706\u73AF */\n.moly-progress-circle circle:last-child {\n  --r: calc((var(--size) - var(--border-width)) / 2);\n  r: var(--r);\n  fill: none;\n  stroke-width: var(--border-width);\n  stroke-linecap: round;\n  transition: stroke-dasharray .4s linear, stroke .3s;\n}\n\n/* \u8FDB\u5EA6\u4E3A0\u65F6\u9690\u85CF\u8FDB\u5EA6\u6761 */\n.moly-progress-value {\n  opacity: var(--percent);\n}\n"])));
var SvgResultCountdownLight = function SvgResultCountdownLight(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? 5 : _ref$time;
  var _useState = useState(time),
    _useState2 = _slicedToArray(_useState, 2),
    countdown = _useState2[0],
    setCountdown = _useState2[1];
  var progressRef = useRef(null);
  var percent = 0;
  var timer = 0;
  var step = function step(countdown) {
    var _progressRef$current, _progressRef$current2;
    var stepNumber = 100 / time;
    setCountdown(countdown - 1);
    percent = percent + stepNumber;
    (_progressRef$current = progressRef.current) === null || _progressRef$current === void 0 || (_progressRef$current = _progressRef$current.style) === null || _progressRef$current === void 0 || _progressRef$current.setProperty('--percent', percent);
    (_progressRef$current2 = progressRef.current) === null || _progressRef$current2 === void 0 || (_progressRef$current2 = _progressRef$current2.style) === null || _progressRef$current2 === void 0 || _progressRef$current2.setProperty('content', 'test');
    if (percent < 100) {
      window.clearTimeout(timer);
      timer = window.setTimeout(step, 1000, countdown - 1);
    }
  };
  useEffect(function () {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timer = window.setTimeout(step, 1000, countdown);
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "moly-progress-circle",
    ref: progressRef,
    style: {
      width: sizeMapWidth[size] || 72,
      height: sizeMapWidth[size] || 72
    },
    children: [/*#__PURE__*/_jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: sizeMapWidth[size] || 72,
      fill: "none",
      viewBox: "0 0 72 72",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7A600",
        fillOpacity: 0.16,
        d: "M36 9C21.088 9 9 21.088 9 36s12.088 27 27 27 27-12.088 27-27S50.912 9 36 9ZM3 36C3 17.775 17.775 3 36 3s33 14.775 33 33-14.775 33-33 33S3 54.225 3 36Z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: 36,
        cy: 36,
        r: 33,
        fill: "#F7A600",
        fillOpacity: 0.16
      }), /*#__PURE__*/_jsx("circle", {
        stroke: "var(--color)",
        cx: 36,
        cy: 36,
        className: "moly-progress-value",
        style: {
          strokeDasharray: "calc(2 * 3.1415 * var(--r) * (var(--percent) / 100)), 1000"
        }
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "moly-progress-circle-text",
      style: {
        color: theme === 'dark' ? '#fff' : '#121214'
      },
      children: countdown
    })]
  });
};
export default SvgResultCountdownLight;